module.exports = __webpack_public_path__ + "img/alex-pro.a2f1d74c.jpg";